import {gql} from '@apollo/client';

export const MUTATION_USER_SETTINGS = gql`
  mutation UserSettings($input: UserSettingsInput!) {
    userSettings(input: $input) {
      obj {
        id
        fullname
        phone
        avatar {
          id
          path
        }
      }
    }
  }
`;

export const MUTATION_USER_CODE = gql`
  mutation UserCode($input: UserCodeInput!) {
    userCode(input: $input) {
      obj {
        id
      }
      errors {
        field
        messages
      }
    }
  }
`;

export const MUTATION_USER_RESTORE = gql`
  mutation UserCode($input: UserRestoreInput!) {
    userRestore(input: $input) {
      obj {
        id
      }
      errors {
        field
        messages
      }
    }
  }
`;
